// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let DevicePixelRatio = require("../v5/common/DevicePixelRatio.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_initiateDevelopmentSampleUnitConversation(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["DevelopmentSampleUnitConversationInitiated"]);
}

let variablesConverter = {"attachmentV5Input":{},"initiateDevelopmentSampleUnitConversationInput":{"images":{"r":"attachmentV5Input"},"files":{"r":"attachmentV5Input"}},"__root":{"input":{"r":"initiateDevelopmentSampleUnitConversationInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"initiateDevelopmentSampleUnitConversation_DevelopmentSampleUnitConversationInitiated_conversation":{"f":""},"initiateDevelopmentSampleUnitConversation":{"u":"response_initiateDevelopmentSampleUnitConversation"}}};

let wrapResponseConverterMap = {
  response_initiateDevelopmentSampleUnitConversation: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"initiateDevelopmentSampleUnitConversation_DevelopmentSampleUnitConversationInitiated_conversation":{"f":""},"initiateDevelopmentSampleUnitConversation":{"u":"response_initiateDevelopmentSampleUnitConversation"}}};

let responseConverterMap = {
  response_initiateDevelopmentSampleUnitConversation: unwrap_response_initiateDevelopmentSampleUnitConversation
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let providedVariablesDefinition = {
  __relay_internal__pv__DevicePixelRatio: {
    providedVariable: DevicePixelRatio.get,
    get: DevicePixelRatio.get
  }
};

function makeNode(providedVariablesDefinition) {
  return ((function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v8 = {
  "kind": "InlineFragment",
  "selections": [
    (v7/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v9 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 500
  }
],
v10 = {
  "kind": "Variable",
  "name": "ratio",
  "variableName": "__relay_internal__pv__DevicePixelRatio"
},
v11 = {
  "kind": "Literal",
  "name": "crop",
  "value": true
},
v12 = {
  "kind": "Literal",
  "name": "width",
  "value": 1200
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ConversationsSectionCommon_InitiateDevelopmentSampleUnitConversationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "initiateDevelopmentSampleUnitConversation",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ConversationV5",
                "kind": "LinkedField",
                "name": "conversation",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ConversationsSectionConversation_conversation"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ConversationsSectionReplyInput_conversation"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "DevelopmentSampleUnitConversationInitiated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__DevicePixelRatio"
      }
    ],
    "kind": "Operation",
    "name": "ConversationsSectionCommon_InitiateDevelopmentSampleUnitConversationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "initiateDevelopmentSampleUnitConversation",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ConversationV5",
                "kind": "LinkedField",
                "name": "conversation",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v3/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "readOnly",
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ConversationParticipantConnection",
                    "kind": "LinkedField",
                    "name": "participants",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ConversationParticipantEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "membershipStatus",
                                    "storageKey": null
                                  }
                                ],
                                "type": "Agent",
                                "abstractKey": null
                              },
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v9/*: any*/),
                    "concreteType": "ConversationMessagesConnection",
                    "kind": "LinkedField",
                    "name": "messages",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ConversationMessagesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ConversationMessageV5",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "state",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "IncomingMessageStatus",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "from",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isConversationParticipantV5"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v4/*: any*/),
                                      (v6/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ProfilePhoto",
                                        "kind": "LinkedField",
                                        "name": "profilePhoto",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": [
                                              (v10/*: any*/),
                                              {
                                                "kind": "Literal",
                                                "name": "width",
                                                "value": 40
                                              }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "url",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "Agent",
                                    "abstractKey": null
                                  },
                                  (v8/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "sentAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "text",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ConversationMessageImageConnection",
                                "kind": "LinkedField",
                                "name": "images",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ConversationMessageImageEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ImageAttachment",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": "oneOfSeveralUrl",
                                            "args": [
                                              (v11/*: any*/),
                                              {
                                                "kind": "Literal",
                                                "name": "height",
                                                "value": 200
                                              },
                                              (v10/*: any*/),
                                              {
                                                "kind": "Literal",
                                                "name": "width",
                                                "value": 200
                                              }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "url",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": [
                                              (v10/*: any*/),
                                              {
                                                "kind": "Literal",
                                                "name": "width",
                                                "value": 400
                                              }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "url",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": "carouselFullscreen",
                                            "args": [
                                              (v10/*: any*/),
                                              (v12/*: any*/)
                                            ],
                                            "kind": "ScalarField",
                                            "name": "url",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": "carouselLarge",
                                            "args": [
                                              {
                                                "kind": "Literal",
                                                "name": "height",
                                                "value": 800
                                              },
                                              (v10/*: any*/),
                                              (v12/*: any*/)
                                            ],
                                            "kind": "ScalarField",
                                            "name": "url",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": "carouselSmall",
                                            "args": [
                                              {
                                                "kind": "Literal",
                                                "name": "embed",
                                                "value": true
                                              },
                                              {
                                                "kind": "Literal",
                                                "name": "height",
                                                "value": 500
                                              },
                                              (v10/*: any*/),
                                              {
                                                "kind": "Literal",
                                                "name": "width",
                                                "value": 750
                                              }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "url",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": "carouselThumb",
                                            "args": [
                                              (v11/*: any*/),
                                              {
                                                "kind": "Literal",
                                                "name": "height",
                                                "value": 90
                                              },
                                              (v10/*: any*/),
                                              {
                                                "kind": "Literal",
                                                "name": "width",
                                                "value": 90
                                              }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "url",
                                            "storageKey": null
                                          },
                                          (v7/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ConversationMessageFileConnection",
                                "kind": "LinkedField",
                                "name": "files",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ConversationMessageFileEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "FileAttachment",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "fileName",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "url",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "key",
                                            "storageKey": null
                                          },
                                          (v7/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "cursor",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "totalCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endCursor",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasNextPage",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "messages(first:500)"
                  },
                  {
                    "alias": null,
                    "args": (v9/*: any*/),
                    "filters": null,
                    "handle": "connection",
                    "key": "ConversationsSectionConversation_messages",
                    "kind": "LinkedHandle",
                    "name": "messages"
                  },
                  (v7/*: any*/),
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "appendNode",
                "key": "",
                "kind": "LinkedHandle",
                "name": "conversation",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  },
                  {
                    "kind": "Literal",
                    "name": "edgeTypeName",
                    "value": "ConversationContextConversationEdge"
                  }
                ]
              }
            ],
            "type": "DevelopmentSampleUnitConversationInitiated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c0fcc0f6fb669beba840a17ede8671fa",
    "id": null,
    "metadata": {},
    "name": "ConversationsSectionCommon_InitiateDevelopmentSampleUnitConversationMutation",
    "operationKind": "mutation",
    "text": "mutation ConversationsSectionCommon_InitiateDevelopmentSampleUnitConversationMutation(\n  $input: InitiateDevelopmentSampleUnitConversationInput!\n  $__relay_internal__pv__DevicePixelRatio: Float!\n) {\n  initiateDevelopmentSampleUnitConversation(input: $input) {\n    __typename\n    ... on DevelopmentSampleUnitConversationInitiated {\n      conversation {\n        id\n        ...ConversationsSectionConversation_conversation\n        ...ConversationsSectionReplyInput_conversation\n        nodeId\n      }\n    }\n  }\n}\n\nfragment ConversationsSectionConversation_MarkConversationAsRead_conversation on ConversationV5 {\n  id\n  messages(first: 500) {\n    edges {\n      node {\n        id\n        status {\n          __typename\n          ... on IncomingMessageStatus {\n            state\n          }\n        }\n        nodeId\n      }\n    }\n  }\n}\n\nfragment ConversationsSectionConversation_conversation on ConversationV5 {\n  ...ConversationsSectionMessage_conversation\n  ...ConversationsSectionReplyInput_conversation\n  ...ConversationsSectionConversation_MarkConversationAsRead_conversation\n  messages(first: 500) {\n    totalCount\n    edges {\n      node {\n        id\n        ...ConversationsSectionMessage_message\n        nodeId\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ConversationsSectionMessageFiles_conversationMessage on ConversationMessageV5 {\n  files {\n    edges {\n      node {\n        fileName\n        url\n        key\n        nodeId\n      }\n    }\n  }\n}\n\nfragment ConversationsSectionMessageImages_OneOfSeveralImages_image on ImageAttachment {\n  oneOfSeveralUrl: url(width: 200, height: 200, crop: true, ratio: $__relay_internal__pv__DevicePixelRatio)\n}\n\nfragment ConversationsSectionMessageImages_SingleImage_image on ImageAttachment {\n  url(width: 400, ratio: $__relay_internal__pv__DevicePixelRatio)\n}\n\nfragment ConversationsSectionMessageImages_conversationMessage on ConversationMessageV5 {\n  images {\n    edges {\n      node {\n        ...ConversationsSectionMessageImages_OneOfSeveralImages_image\n        ...ConversationsSectionMessageImages_SingleImage_image\n        carouselFullscreen: url(width: 1200, ratio: $__relay_internal__pv__DevicePixelRatio)\n        carouselLarge: url(width: 1200, height: 800, ratio: $__relay_internal__pv__DevicePixelRatio)\n        carouselSmall: url(width: 750, height: 500, embed: true, ratio: $__relay_internal__pv__DevicePixelRatio)\n        carouselThumb: url(width: 90, height: 90, crop: true, ratio: $__relay_internal__pv__DevicePixelRatio)\n        nodeId\n      }\n    }\n  }\n}\n\nfragment ConversationsSectionMessage_conversation on ConversationV5 {\n  __typename\n  visibility\n}\n\nfragment ConversationsSectionMessage_message on ConversationMessageV5 {\n  from {\n    __typename\n    ... on Agent {\n      id\n      displayName\n    }\n    ... on AnonymousConversationParticipant {\n      __typename\n    }\n    ...ConversationsSectionParticipantProfilePhoto_participant\n    ... on Node {\n      __isNode: __typename\n      __typename\n      nodeId\n    }\n  }\n  sentAt\n  text\n  ...ConversationsSectionMessageImages_conversationMessage\n  ...ConversationsSectionMessageFiles_conversationMessage\n}\n\nfragment ConversationsSectionParticipantProfilePhoto_participant on ConversationParticipantV5 {\n  __isConversationParticipantV5: __typename\n  __typename\n  ... on Agent {\n    displayName\n    profilePhoto {\n      url(width: 40, ratio: $__relay_internal__pv__DevicePixelRatio)\n    }\n  }\n  ... on AnonymousConversationParticipant {\n    __typename\n  }\n}\n\nfragment ConversationsSectionReplyInput_DeactivatedConversationWarning_conversation on ConversationV5 {\n  participants {\n    edges {\n      node {\n        __typename\n        ... on Agent {\n          displayName\n          membershipStatus\n        }\n        ... on Node {\n          __isNode: __typename\n          __typename\n          nodeId\n        }\n      }\n    }\n  }\n}\n\nfragment ConversationsSectionReplyInput_conversation on ConversationV5 {\n  id\n  readOnly\n  visibility\n  ...ConversationsSectionReplyInput_DeactivatedConversationWarning_conversation\n}\n",
    "providedVariables": providedVariablesDefinition
  }
};
})());
}

let node = makeNode(providedVariablesDefinition);

let wrap_response_initiateDevelopmentSampleUnitConversation = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_initiateDevelopmentSampleUnitConversation = unwrap_response_initiateDevelopmentSampleUnitConversation;
exports.wrap_response_initiateDevelopmentSampleUnitConversation = wrap_response_initiateDevelopmentSampleUnitConversation;
exports.Internal = Internal;
exports.Utils = Utils;
exports.providedVariablesDefinition = providedVariablesDefinition;
exports.node = node;
/* node Not a pure module */
